import CaretLinkWhiteVariation from './CaretLinkWhiteVariation'

export default CaretLinkWhiteVariation
